import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CompanyDetails from '../../components/company-details/CompanyDetails';
import { useNavigate } from "react-router";

const StepTwo = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let productPrice     = useSelector(state => state.productPrice);
    let isShop     = useSelector(state => state.isShop);
    let minThreshold     = useSelector(state => state.minThreshold);
    let maxThreshold     = useSelector(state => state.maxThreshold);

    let navigate = useNavigate();
    const dispatch = useDispatch()

    useEffect(() => {
        if ( !load ) {
            window.scrollTo(0, 0);
            if ( productPrice < minThreshold ) {
                dispatch({ type: 'STEPS_CHANGE', value: 2 })
                 
              } 
              else if( productPrice >= minThreshold && productPrice < maxThreshold ) {
                dispatch({ type: 'STEPS_CHANGE', value: 2 })
                  
              } 
              else if( productPrice >= maxThreshold) {
                dispatch({ type: 'STEPS_CHANGE', value: 2 })
                
              } 
              else {
                dispatch({ type: 'STEPS_CHANGE', value: 2 })
              }
              if(typeof window !== "undefined") {
                window.dataLayer.push({'event':'pageview'});
              }
            setLoad(true);
        } 
    }, [load])

    let prev = () => {
      navigate(isShop ? '/shop':'/')
    }
    let next = () => {
      navigate('/step/3')
    }

    return (
      <section className="form steps">
          <div className="container-step">
              <div className="row" >
                  <CompanyDetails prev={ () => prev() } next={ () => next() } />
              </div>
          </div>
      </section>
    )
}

export default StepTwo;